/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Calm_Body_OneInputs */



/**
* | output |
* | --- |
* | "The one open partner-month has complete data and a confirmed tax country." |
*
* @param {Partner_Billing_Board_Calm_Body_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_calm_body_one = /** @type {((inputs?: Partner_Billing_Board_Calm_Body_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Calm_Body_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der eine offene Partnermonat hat vollständige Daten und ein bestätigtes Steuerland.")
	return /** @type {LocalizedString} */ ("The one open partner-month has complete data and a confirmed tax country.")
});